var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 167 168",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.623 70.908S53.25 18.188 19.184 1.008C15.343-.933 7.988.067 4.944 2.814 1.899 5.565.254 10.212.21 14.098c-.01.96-.012 2.077.236 3.05C4.195 31.712 11.16 53.115 17.005 75.442c.034.13 84.345-.18 84.164.251-.014.037 6.119 1.29 6.4 7.68.227 5.154-3.941 7.522-6.319 8.051-1.178.265-84.007-.251-84.199.47C9.66 119.747 3.321 139.7.13 154.45c-.66 3.058 1.3 6.064 3.422 8.598.993 1.186 3.411 3.053 6.36 3.738 3.421.794 7.32.309 9.129-.555C54.996 149.072 158.12 96.7 158.12 96.7c4.983-2.913 7.815-7.177 7.9-13.166-.072-5.25-2.487-9.48-7.397-12.626z"
  })));
}
export default SvgSend;